import { EnvironmentConfigType } from '@smx-ui-relay/relay-types';

import { API } from '../common';

const isLocalhost =
    typeof window !== 'undefined' && ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);

export const EnvironmentConfig: EnvironmentConfigType = {
    devToken: API.GRAPHQL_TOKEN,
    authUrl: '',
    envName: isLocalhost ? 'development' : 'production',
    loadToken: () => Promise.resolve(null),
    saveToken: () => Promise.resolve(),
};
